export default __webpack_public_path__ + "static/20-39a62ff48246f85785f967660e788dd0.jpg";